import React__default from 'react';
import StatusIcon from './StatusIcon.js';
import { IconTransition, NotStarted, FadeInScaleIcon, Connector, ConnectorProgress } from './styles.js';
import animationStepStatus from './utils/animationStepStatus.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function StepIndicator({
  animationStep,
  currentStepNumber,
  status,
  step,
  stepsCount
}) {
  const currentAnimationStatus = animationStepStatus(step, status, animationStep, currentStepNumber, stepsCount);
  return jsxs(React__default.Fragment, {
    children: [jsxs(IconTransition, {
      children: [jsx(NotStarted, {}), jsx(FadeInScaleIcon, {
        animate: animationStep >= step,
        children: jsx(StatusIcon, {
          status: currentAnimationStatus
        })
      })]
    }), step !== stepsCount ? jsx(Connector, {
      testID: `step-indicator-connector-${step}`,
      children: jsx(ConnectorProgress, {
        stepComplete: animationStep >= step && step !== currentStepNumber
      })
    }) : null]
  });
}

export { StepIndicator as default };
